<template>
  <div class="flex flex-col items-center gap-y-7.5">
    <UiLazyImg
      class="mx-auto w-[150px] flex-1 opacity-50"
      cover
      src="/images/no-orders.svg"
      alt="No orders placed yet"
    />
    <p class="text-lgx font-medium capitalize text-gray-bag">
      {{ $t("noOrdersPlacedYet") }}
    </p>
    <p class="text-center leading-[1.5] -tracking-[0.16px] text-gray-dark">
      {{ $t("noOrderText") }}
    </p>
    <UiButton
      :to="localePath('/')"
      color="primary"
      variant="outlined"
      class="!px-5 !py-2.5 font-medium uppercase"
      >{{ $t("continueShopping") }}</UiButton
    >
  </div>
</template>

<script setup lang="ts">
const localePath = useLocalePathPolyfill();
</script>
